import React, { useEffect, useRef, useState } from "react";
import './PackageScan.css';
import OdooService from '../../../services/odooService';
import { useNavigate, useLocation } from "react-router-dom";
import ErrorModal from "../../../components/ErrorModal/ErrorModal";
import LoadingOverlay from "../../../components/LoadingOverlay/LoadingOverlay";

const PackageScan = ({ onPackagesScanned }) => {
    const navigate = useNavigate();
    const handleBack = () => navigate(-1);

    const [packages, setPackages] = useState([]);
    const [totalPackages, setTotalPackages] = useState([]);
    const [scannedPackages, setScannedPackages] = useState([]);
    const [missingPackages, setMissingPackages] = useState([]);
    const [currentScan, setCurrentScan] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const inputRef = useRef(null);
    const scanInputRef = useRef(null);
    const scanTimer = useRef(null);
    const location = useLocation();
    const { location_id, location_name, package_name } = location.state || {};

    useEffect(() => {
        const last = localStorage.getItem("lastScan");

        if (package_name && last !== package_name) {
            packageToInventory(package_name);
            localStorage.setItem("lastScan", package_name);
        }
    }, [package_name]);

    useEffect(() => {
        if (location_id) {
            loadData(location_id)
        }
    }, []);

    const loadData = async (location_id) => {
        setLoading(true);
        try {
            const result = await OdooService.loadInventoryIndicators(location_id);
            if (result.success) {
                setTotalPackages(result.total);
                setScannedPackages(result.scanned);
                setMissingPackages(result.missing)
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (scanInputRef.current) scanInputRef.current.focus();
    }, []);

    useEffect(() => {
        if (error === "" && scanInputRef.current) {
            setTimeout(() => scanInputRef.current.focus(), 50);
        }
    }, [error]);

    const handleManualChange = (e) => {
        setCurrentScan(e.target.value);
    };

    const handleManualKeyDown = async (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const code = currentScan.trim();
            if (code !== "" && !packages.some(pkg => pkg.name === code)) {
                await packageToInventory(code);
            }
            setCurrentScan("");
        }
    };

    const handleScannerChange = (e) => {
        const value = e.target.value;
        if (!value) return;

        if (scanTimer.current) clearTimeout(scanTimer.current);

        scanTimer.current = setTimeout(() => {
            packageToInventory(value.trim());
            scanInputRef.current.value = "";
        }, 120);
    };

    const handleScannerKeyDown = (e) => {
        if (
            e.key === "Backspace" ||
            e.key === "Enter" ||
            e.key === "BrowserBack" ||
            e.key.length > 1
        ) {
            e.preventDefault();
        }
    };

    const packageToInventory = async (barcode) => {
        if (!barcode || !location_id) {
            setError("Código de paquete o ubicación inválida");
            return;
        }

        setError("");
        setLoading(true);

        try {
            const session = JSON.parse(localStorage.getItem("odoo_session"));
            const userId = session?.userId.uid;
            const result = await OdooService.packageToInventory(userId, location_id, barcode);

            if (result.success) {
                loadData(location_id);
            } else {
                setError(result.message);
                if (scanInputRef.current) {
                    scanInputRef.current.focus();
                    scanInputRef.current.select();
                }
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
            if (scanInputRef.current) scanInputRef.current.focus();
        } finally {
            setLoading(false);
        }
    };

    const navigateToPackageList = (type) => {
        navigate("/packagelist", {
            state: {
                type,
                location_id
            }
        });
    };


    return (
        <div className="package-step">
            <header className="package-header">
                <h1 className="package-title">Toma de inventario</h1>
                <p className="package-subtitle">Escanear Paquetes</p>
            </header>

            <div className="package-content">
                <div className="package-form">

                    <div className="package-location">
                        <strong>Ubicación:</strong> {location_name}
                    </div>

                    <div className="package-input-group">
                        <input
                            ref={inputRef}
                            type="text"
                            value={currentScan}
                            onChange={handleManualChange}
                            onKeyDown={handleManualKeyDown}
                            className="package-input"
                            placeholder="Digita o escanea manualmente"
                        />

                        <input
                            ref={scanInputRef}
                            className="scan-input"
                            type="text"
                            onChange={handleScannerChange}
                            onKeyDown={handleScannerKeyDown}
                            autoFocus
                            inputMode="none"
                        />
                    </div>
                </div>
            </div>

            <div className="inventory-package-indicators">
                <div className="inventory-total-packages">
                    <strong>Total de paquetes</strong>
                    <p></p>
                    <button
                    onClick={() => navigateToPackageList("total")}>
                        {totalPackages}
                    </button>
                </div>

                <div className="inventory-scanned-packages">
                    <strong>Paquetes escaneados</strong>
                    <p></p>
                    <button
                    onClick={() => navigateToPackageList("scanned")}>
                        {scannedPackages}
                    </button>
                </div>

                <div className="inventory-missing-packages">
                    <strong>Paquetes faltantes</strong>
                    <p></p>
                    <button
                    onClick={() => navigateToPackageList("missing")}>
                        {missingPackages}
                    </button>
                </div>
            </div>

            <div className="package-actions">
                <button
                    onClick={handleBack}
                    className="btn-package btn-secondary-package"
                >
                    Volver
                </button>
            </div>

            {loading && <LoadingOverlay message="Cargando..." />}

            <ErrorModal message={error} onClose={() => setError("")} />
        </div>
    );
};

export default PackageScan;
